/**
 * Collab 목록 리포지토리 — 서버 사이드 fetch (게스트 접근).
 * @description `shared/lib/collabs/api.ts`(상세)와 같은 방식이다. 브라우저가 아니라 서버가
 *   부르므로 API 주소가 번들에 노출되지 않고 응답을 ISR 로 캐시할 수 있다.
 *
 *   게스트로 부르므로 공개 범위가 PUBLIC 인 콜랩만 온다.
 */
import type { GetCollabListQuery, GetCollabListResponse } from "../dtos";
import { pageOf } from "@/mocks/fixtures/paging";
import { MOCK_COLLAB_LIST } from "@/mocks/fixtures/collabList";
import { fetchJson } from "@/shared/lib/http";

const BASE_URL = process.env.API_BASE_URL;
const USE_MOCK = process.env.NEXT_PUBLIC_API_MOCK === "1";
const DEFAULT_LIMIT = 20;

/** GET /web/collabs — 필터 없는 전체 목록(커서 페이지). Collab Spotlights 가 쓰는 소스다 */
export function getCollabs(
  query: GetCollabListQuery = {},
): Promise<GetCollabListResponse> {
  const limit = query.limit ?? DEFAULT_LIMIT;
  if (USE_MOCK) {
    const page = pageOf(MOCK_COLLAB_LIST, query.cursor, limit);
    return Promise.resolve({ ...page, totalCount: MOCK_COLLAB_LIST.length });
  }
  const params = new URLSearchParams({ limit: String(limit) });
  if (query.cursor) params.set("cursor", query.cursor);
  return fetchJson(`${BASE_URL}/web/collabs?${params}`, "getCollabs");
}
